import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { Trash2 } from "lucide-react";
import FormField from "../../components/FormField";
import IconButton from "../../components/IconButton";
import TextInput from "../../components/TextInput";

const errorFor = (errors, path) => errors?.[path]?.[0] || "";

const ExternalCOSSUser = (props) => {
  const { handleInputChange } = props;
  const userData = props.userData || {};
  const userIndex = props.userIndex;
  const valuePath = `users.cossXusers.${userIndex}`;

  useEffect(() => {
    if (!userData.user_reference) handleInputChange(`${valuePath}.user_reference`, uuidv4(), { systemSync: true });
  }, [handleInputChange, userData.user_reference, valuePath]);

  const field = (name, label, required = false) => (
    <FormField error={errorFor(props.errors, `data.users.cossXusers.${userIndex}.${name}`)} id={`external-${name}-${userIndex}`} label={label} required={required}>
      {(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`${valuePath}.${name}`, event.target.value)} value={userData[name] || ""} />}
    </FormField>
  );

  return (
    <article className="wsm-pack-form-section__entry">
      <div className="wsm-pack-form-section__entry-heading"><h4>External user {userIndex + 1}</h4><IconButton aria-label={`Remove external user ${userIndex + 1}`} icon={Trash2} onClick={() => props.handleRemoveFormRow("users.cossXusers", userIndex, true, "external IWA/COSS user")} size="compact" variant="destructive" /></div>
      <div className="wsm-pack-form__field-grid wsm-pack-form__field-grid--four">
        {field("name", "Name")}
        {field("location", "Location")}
        {field("tasks", "Tasks")}
        {field("phone_no", "Phone number", true)}
      </div>
    </article>
  );
};

export default ExternalCOSSUser;
